/**
 * Rotas de abas do módulo Wealth Service — fonte única do header (Novo Design
 * 2026). Cada item tem `title`/`subtitle`: o `NavBarNavigation` (com
 * `route-header`) usa como cabeçalho da página quando a Navegação 2026 está
 * ligada, e o `ConditionalTeleport` das views resolve o mesmo header inline
 * quando ela está desligada.
 */
export const wsRoutes = () => [
  {
    name: 'ws.clients',
    title: 'Clientes',
    subtitle: 'Gerencie seus clientes e suas operações',
  },
  {
    name: 'ws.operations',
    title: 'Operações',
    subtitle: 'Gerencie todas as operações dos seus clientes',
  },
  {
    name: 'ws.ativos',
    title: 'Ativos',
    subtitle: 'Gerencie todos os ativos disponíveis',
  },
  {
    name: 'ws.recommended-portfolios',
    title: 'Carteiras Recomendadas',
    subtitle: 'Visualize as carteiras recomendadas disponíveis',
  },
]

// Header da aba Solicitações — FONTE ÚNICA para os dois branches de navegação.
// O `ConditionalTeleport` resolve o header de dois lugares diferentes: com o
// Nav 2026 LIGADO vem do item de rota da `ws-nav-bar`; DESLIGADO vem das props
// `title`/`subtitle` da própria view. Com o texto escrito nos dois lugares eles
// já tinham divergido ("Pedidos abertos…" × "Acompanhe os pedidos abertos…") —
// a mesma tela dizia coisas diferentes dependendo da flag do escritório.
//
// A aba não entra em `wsRoutes()` porque ela é acrescentada à parte na nav-bar
// (não faz parte do conjunto de abas base compartilhado com o header).
export const WS_SOLICITACOES_HEADER = {
  title: 'Solicitações',
  subtitle: 'Acompanhe os pedidos abertos para o time de backoffice da AAWZ',
}

/**
 * Marcador de tela que ainda não tem backend.
 *
 * A sub-área de Backoffice (10 telas) não tem endpoint: o módulo `aawz_ws` do
 * `aawz-web-backend` expõe QUATRO rotas, todas de operações
 * (`aawz_ws/routes.py`). Nove classes de API do módulo respondiam por fixture
 * em memória; desde 23/08/2026 elas respondem VAZIO por padrão (ver
 * `constants/mock-mode.js`), então a tela mostra o próprio estado de "nenhum
 * registro" em vez de dado inventado.
 *
 * O sufixo dizia "(mock)". Deixou de ser verdade quando o seed foi desligado —
 * e a distinção importa para quem abre a tela: mock é dado falso, isto aqui é
 * ausência de integração. Sem a marcação, uma tabela vazia parece um escritório
 * sem movimento, que é uma leitura pior que "ainda não conectamos".
 *
 * Marcado no nível da ÁREA, não em cada uma das 9 sub-abas: repetir o sufixo
 * nove vezes na mesma linha de navegação é ruído, e a informação é a mesma.
 *
 * PARA REMOVER: quando uma tela for integrada, tire o sufixo do ponto
 * correspondente. Quando TODAS estiverem, apague esta constante — o grep por
 * `SUFIXO_MOCK` acha os call-sites.
 */
export const SUFIXO_MOCK = ' (sem integração)'

/**
 * Travessão de "sem dado". Estava triplicado como `const DASH = '—'` local em
 * `view-ws-solicitacao-detalhe.vue:19`, `view-ws-solicitacao-nova.vue:21` e
 * `view-onboarding-form.vue:18` — centralizado aqui porque
 * `utils/valorExibicao.js` passou a ser o quarto consumidor.
 *
 * Travessão (—), não hífen (-) nem string vazia: célula em branco lê como falha
 * de renderização, e o hífen se confunde com sinal negativo em coluna de valor.
 */
export const DASH = '—'
